import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import type { ExperienceEvent } from '@atlassian/experience-tracker';

import {
	collectAllWithSubExperienceAttributes,
	type Experience,
	failExperienceOnSubExperienceFail,
} from '../aifc-experience-collect-helpers';

/**
 * Create a collect function for the AIFC_GENERATE_CONTENT, AIFC_UPDATE_CONTENT, and UPDATE_CONTENT_IN_CHAT experiences.
 * This function will collect the AIFC_MESSAGE and AIFC_ALL_DATA_HANDLED experiences and mirror their success/fail/abort events to the parent experience.
 * If AIFC_INITIAL_DATA_RECEIVED fails (timeout or error), it will fail the parent experience.
 *
 * @returns A collect function for the AIFC_GENERATE_CONTENT and AIFC_UPDATE_CONTENT experiences
 */
export const createAifcExperienceCollect = () => {
	const additionalAttributes: { isInitialDataReceived: boolean | null } = { isInitialDataReceived: null };
	const subExperienceCollect = collectAllWithSubExperienceAttributes(
		[ExperienceName.AIFC_MESSAGE, ExperienceName.AIFC_ALL_DATA_HANDLED],
		additionalAttributes,
	);
	return (events: ExperienceEvent[], experience: Experience): void => {
		for (const event of events) {
			if (
				event.name === ExperienceName.AIFC_INITIAL_DATA_RECEIVED
			) {
				if (event.action === 'taskSuccess') {
				additionalAttributes.isInitialDataReceived = true;
				} else if (event.action === 'taskFail') {
					additionalAttributes.isInitialDataReceived = false;
				}
			}
		}

		// If AIFC_INITIAL_DATA_RECEIVED fails, fail AIFC_GENERATE_CONTENT
		failExperienceOnSubExperienceFail(
			ExperienceName.AIFC_INITIAL_DATA_RECEIVED,
			experience,
			events,
			additionalAttributes,
		);

		subExperienceCollect(events, experience);
	};
};
